<template>
  <div id="app">
<!--      <router-view :key="key"></router-view>-->
      <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
    export default{
        name: 'app',
        computed:{
            key(){
                console.log(this.$route.name)
                if(this.$route.name=='userInfo'){
                    return this.$route.name?this.$route.name+' '+new Date():this.$route+ +new Date()
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/App.vue